const LinkArrow = ({ ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7906 2.26676L10.3999 2.26688C10.0317 2.26689 9.73322 1.96843 9.7332 1.60024C9.73318 1.23205 10.0316 0.933561 10.3998 0.933543L14.4002 0.93335C14.577 0.933341 14.7466 1.00358 14.8717 1.1286C14.9967 1.25363 15.0669 1.4232 15.0669 1.60002V5.20011C15.0669 5.5683 14.7685 5.86678 14.4003 5.86678C14.0321 5.86678 13.7336 5.5683 13.7336 5.20011V3.20936L8.07105 8.87125C7.81069 9.13159 7.38858 9.13157 7.12824 8.8712C6.86791 8.61084 6.86793 8.18873 7.1283 7.92839L12.7906 2.26676ZM4.00026 2.26668C3.04297 2.26668 2.26693 3.04272 2.26693 4.00002V12.0001C2.26693 12.9574 3.04297 13.7334 4.00026 13.7334H12.0003C12.9576 13.7334 13.7336 12.9574 13.7336 12.0001V8.80002C13.7336 8.43183 14.0321 8.13335 14.4003 8.13335C14.7684 8.13335 15.0669 8.43183 15.0669 8.80002V12.0001C15.0669 13.6938 13.6939 15.0668 12.0003 15.0668H4.00026C2.30659 15.0668 0.933594 13.6938 0.933594 12.0001V4.00002C0.933594 2.30634 2.30659 0.93335 4.00026 0.93335H7.20026C7.56845 0.93335 7.86693 1.23183 7.86693 1.60002C7.86693 1.96821 7.56845 2.26668 7.20026 2.26668H4.00026Z"
        fill="#FB3973"
      />
    </svg>
  );
};

export default LinkArrow;
